import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide10Contacts({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-229">
      <SlideHeader eyebrow="12-Month Proposal" data-id="element-230">
        12-month model: full annual engagement loop with better value
      </SlideHeader>

      <div className="flex-1 flex flex-col max-w-6xl mx-auto w-full relative" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="absolute -top-16 right-0 bg-[var(--brand)] text-white px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 shadow-lg" data-id="element-232">
          <Star className="h-4 w-4 fill-current" data-id="element-233" />
          RECOMMENDED
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-8 max-w-4xl" data-id="element-234">
          For a 12-month commitment, GSK Morocco receives a 10% discount on
          campaign adaptations and master updates. The discount does not apply
          to the initial master production.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border-2 border-[var(--brand)]/20 overflow-hidden" data-id="element-235">
          <table className="w-full text-left border-collapse" data-id="element-236">
            <thead data-id="element-237">
              <tr className="bg-[var(--surface)] border-b border-black/5" data-id="element-238">
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-239">
                  Item
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider text-center" data-id="element-240">
                  Quantity
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider text-right" data-id="element-241">
                  Unit Price
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--brand)] uppercase tracking-wider text-right" data-id="element-242">
                  Discounted Price
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider text-right" data-id="element-243">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-black/5" data-id="element-244">
              <tr className="hover:bg-black/[0.02] transition-colors" data-id="element-245">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-246">
                  Master Teaser
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-247">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)]" data-id="element-248">
                  €2,500
                </td>
                <td className="py-4 px-6 text-right text-[var(--muted)] text-sm" data-id="element-249">
                  No discount
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-250">
                  €2,500
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors" data-id="element-251">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-252">
                  Master Trailer / Microsite
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-253">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)]" data-id="element-254">
                  €3,500
                </td>
                <td className="py-4 px-6 text-right text-[var(--muted)] text-sm" data-id="element-255">
                  No discount
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-256">
                  €3,500
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors bg-[var(--brand)]/5" data-id="element-257">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-258">
                  Monthly campaign adaptations
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-259">
                  12
                </td>
                <td className="py-4 px-6 text-right text-[var(--muted)] line-through" data-id="element-260">
                  €600
                </td>
                <td className="py-4 px-6 text-right font-bold text-[var(--brand)]" data-id="element-261">
                  €540
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-262">
                  €6,480
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors bg-[var(--brand)]/5" data-id="element-263">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-264">
                  Teaser Master Update
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-265">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)] line-through" data-id="element-266">
                  €1,250
                </td>
                <td className="py-4 px-6 text-right font-bold text-[var(--brand)]" data-id="element-267">
                  €1,125
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-268">
                  €1,125
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors bg-[var(--brand)]/5" data-id="element-269">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-270">
                  Trailer / Microsite Master Update
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-271">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)] line-through" data-id="element-272">
                  €2,250
                </td>
                <td className="py-4 px-6 text-right font-bold text-[var(--brand)]" data-id="element-273">
                  €2,025
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-274">
                  €2,025
                </td>
              </tr>
            </tbody>
            <tfoot data-id="element-275">
              <tr className="bg-[var(--brand)] text-white" data-id="element-276">
                <td colSpan={4} className="py-5 px-6 font-bold text-lg uppercase tracking-wider" data-id="element-277">
                  Total 12-month proposal
                </td>
                <td className="py-5 px-6 text-right font-bold text-2xl" data-id="element-278">
                  €15,630
                </td>
              </tr>
            </tfoot>
          </table>
        </motion.div>
      </div>
    </InteriorSlide>;
}